import React from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Button } from "antd";
import { useVarParam } from "components/use-hooks";

import Icons from "../icons";

const BackButton = ({ logo = false }) => {
    const appParams = useVarParam();
    const history = useHistory(),
          location = useLocation();
    const logoRoutes = [
        "/",
        "/more",
        "/more/",
        "/more/my-time-records"
    ];

    if(logoRoutes.includes(location.pathname) || logo){
        return(
            <Link
                to="/"
                className="menu-button home"
            >
                <Icons.Logo className="logo"/>
            </Link>
        )
    }

    const goBackLink = location.state && location.state.from ? location.state.from : "/";

    const handleBackClick = () => {
        appParams.set({
            headerTitle: null
        });

        if(goBackLink !== "/"){
            if (
                location.state &&
                Object.prototype.hasOwnProperty.call(location.state, "returnPagePosition")
            ){
                history.replace(
                    goBackLink,
                    {
                        pagePosition : location.state.returnPagePosition,
                        returnStandId: location.state.returnStandId
                    }
                )
            } else {
                history.go(-1)
            }
        } else {
            history.push(goBackLink)
        }
    };

    return(
        <Button
            onClick={handleBackClick}
            className="back-button icon rounded"
        >
            <Icons.Arrow type="full" />
        </Button>
    );
};

export default BackButton;
